import { render, staticRenderFns } from "./ChoosePersonDepart.vue?vue&type=template&id=29eb787b&scoped=true&"
import script from "./ChoosePersonDepart.vue?vue&type=script&lang=js&"
export * from "./ChoosePersonDepart.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePersonDepart.vue?vue&type=style&index=0&id=29eb787b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eb787b",
  null
  
)

export default component.exports